/**
 * Lab Backend-UI `highStock.js` series builders — Back/Lay rate lines + bet scatters.
 */

import type { LabRateTick } from './fetchRunnerRates'
import type { SurveillanceBet } from './types'

export type HighstockRatePoint = {
  x: number
  y: number
  rateObj: LabRateTick
}

export type HighstockBetPoint = {
  x: number
  y: number
  bet: SurveillanceBet
}

/** Lab `ratesSuccess` — carry-forward `b`/`l`, attach tick for volume tooltips. */
export function labTicksToHighstockRates(ticks: LabRateTick[]): {
  backRate: HighstockRatePoint[]
  layRate: HighstockRatePoint[]
} {
  // Sort first so Lab's monotonic `oldDate` carry-forward stays correct.
  const ordered = ticks
    .filter((m) => Number.isFinite(m.d))
    .slice()
    .sort((a, b) => a.d - b.d)

  let oldBackRate = 0
  let oldDate = 0
  const backRate: HighstockRatePoint[] = []
  for (const m of ordered) {
    const date = m.d * 1000
    if (typeof m.b === 'number' && Number.isFinite(m.b)) oldBackRate = m.b
    if (oldDate < date) oldDate = date
    backRate.push({ x: oldDate, y: oldBackRate, rateObj: m })
  }

  let oldLayRate = 0
  const layRate: HighstockRatePoint[] = []
  for (const m of ordered) {
    const date = m.d * 1000
    if (typeof m.l === 'number' && Number.isFinite(m.l)) oldLayRate = m.l
    layRate.push({ x: date, y: oldLayRate, rateObj: m })
  }

  return { backRate, layRate }
}

/** Lab `betsSuccess` — scatter points for matched BACK/LAY stakes. */
export function betsToHighstockScatter(bets: SurveillanceBet[]): {
  backBets: HighstockBetPoint[]
  layBets: HighstockBetPoint[]
} {
  const backBets: HighstockBetPoint[] = []
  const layBets: HighstockBetPoint[] = []
  for (const m of bets) {
    if (!(m.s > 0) || !Number.isFinite(m.p) || !Number.isFinite(m.d)) continue
    const point: HighstockBetPoint = { x: m.d * 1000, y: m.p, bet: m }
    if (m.t === 'LAY') layBets.push(point)
    else if (m.t === 'BACK') backBets.push(point)
  }
  return { backBets, layBets }
}
